import { createStore, applyMiddleware, combineReducers } from 'redux'
import createSagaMiddleware from 'redux-saga'
import sagas from '../sagas'
import * as reducers from '../reducers'
import { composeWithDevTools } from 'redux-devtools-extension'
import { loadingMiddleware, loadingReducer } from '../middlewares/loading'
import initReducer from '../middlewares/init'

const sagaMiddleware = createSagaMiddleware()
const enhancer = composeWithDevTools(applyMiddleware(sagaMiddleware, loadingMiddleware()))
const configureStore = preloadedState => {
    const store = createStore(
        initReducer(
            combineReducers({
                ...reducers,
                loading: loadingReducer
            })
        ),
        preloadedState,
        enhancer
    )
    if (module.hot) {
        module.hot.accept('../reducers', () =>
            store.replaceReducer(require('../reducers'))
        )
    }
    sagaMiddleware.run(sagas)
    return store
}
export default configureStore
